var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6655_107633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1C3.243 1 1 3.243 1 6C1 8.757 3.243 11 6 11C8.757 11 11 8.757 11 6C11 3.243 8.757 1 6 1ZM6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6C12 7.5913 11.3679 9.11742 10.2426 10.2426C9.11742 11.3679 7.5913 12 6 12C4.4087 12 2.88258 11.3679 1.75736 10.2426C0.632141 9.11742 0 7.5913 0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71456 5.5535H7.28599V4.26779C7.28599 3.5577 6.71036 2.98207 6.00028 2.98207C5.2902 2.98207 4.71456 3.55771 4.71456 4.26779V5.5535H4.28599C4.0493 5.5535 3.85742 5.74538 3.85742 5.98207V8.5535C3.85742 8.79019 4.0493 8.98207 4.28599 8.98207H7.71456C7.95126 8.98207 8.14313 8.79019 8.14313 8.5535V5.98207C8.14313 5.74538 7.95126 5.5535 7.71456 5.5535ZM5.14314 4.26779C5.14314 3.7944 5.52689 3.41064 6.00028 3.41064C6.47367 3.41064 6.85742 3.7944 6.85742 4.26779V5.5535H5.14314V4.26779Z",
    fill: "#203662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6655_107633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked1);
export default __webpack_public_path__ + "static/media/Locked1.f8402013b3de0cecef027a83e4eb20f6.svg";
export { ForwardRef as ReactComponent };